var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// libs
import React, { memo } from 'react';
// HOC
import withIconDefaults from './withIconDefaults';
function IconWarning(_a) {
    var { fillColor } = _a, props = __rest(_a, ["fillColor"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 15 14", fill: "none" }, props),
        React.createElement("path", { d: "M8.38148 0.645429C8.00449 -0.0582758 6.9955 -0.0582756 6.61852 0.645429L0.78869 11.5278C0.431815 12.1939 0.914434 13 1.67017 13H13.3298C14.0856 13 14.5682 12.1939 14.2113 11.5278L8.38148 0.645429ZM6.875 4.71591C6.875 4.37073 7.15482 4.09091 7.5 4.09091C7.84518 4.09091 8.125 4.37073 8.125 4.71591V7.92045C8.125 8.26563 7.84518 8.54545 7.5 8.54545C7.15482 8.54545 6.875 8.26563 6.875 7.92045V4.71591ZM7.5 11.25C7.06875 11.25 6.71875 10.8936 6.71875 10.4545C6.71875 10.0155 7.06875 9.65909 7.5 9.65909C7.93125 9.65909 8.28125 10.0155 8.28125 10.4545C8.28125 10.8936 7.93125 11.25 7.5 11.25Z", fill: fillColor })));
}
export default memo(withIconDefaults(IconWarning));
